import { render, staticRenderFns } from "./VolumePrecoForm.vue?vue&type=template&id=71f65d59&scoped=true&"
import script from "./VolumePrecoForm.vue?vue&type=script&lang=js&"
export * from "./VolumePrecoForm.vue?vue&type=script&lang=js&"
import style0 from "./VolumePrecoForm.vue?vue&type=style&index=0&id=71f65d59&scoped=true&lang=css&"
import style1 from "./VolumePrecoForm.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f65d59",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardActions,VCol,VContainer,VIcon,VRow,VTooltip})
